import type { Organization } from "@entities";
import { Roles } from "@shared/Roles";
import { ForbiddenError, remult, type EntityFilter } from "remult";

interface CurrentUser {
  id: string;
}

export function isAdminsOrCurrentUser(user?: CurrentUser) {
  return (
    user?.id === remult.user?.id ||
    remult.isAllowed(Roles.AdminsAndManager) ||
    false
  );
}

export function isSuperAdminOrCurrentUser(user?: CurrentUser) {
  return (
    user?.id === remult.user?.id ||
    remult.isAllowed(Roles.SuperAdmin) ||
    remult.isAllowed(Roles.SuperDuperAdmin) ||
    false
  );
}

export function isThisOrganizationAdmin(): EntityFilter<Organization> {
  const organizationId = remult.user?.organizationId;

  if (remult.isAllowed(Roles.SuperDuperAdmin)) return {};

  if (!organizationId) {
    if (remult.isAllowed(Roles.User)) {
      return {};
    } else {
      console.error("no org id");
      throw new ForbiddenError();
    }
  }

  return {
    id: organizationId,
  };
}
